import { genQueryJsonStr } from '@/utils/querySchema'

export default function () {
  function goPage(query = { }) {
    this.$router.push(`/driver/customerManage?query=${genQueryJsonStr(query)}`)
  }
  function renderContent(row, key, query) {
    return this.$createElement('span', {
      class: 'item-active',
      on: {
        click: () => { goPage.call(this, query) },
      },
    }, row[key])
  }
  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'customerNum',
      columnProps: {
        label: '新增用户数',
        prop: 'customerNum',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'customerNum')
      },
      columnHeaderTooltip: '新增个人用户+企业用户数量',
    },
    {
      name: 'orderNum',
      columnProps: {
        label: '新增订单数',
        prop: 'orderNum',
      },
      columnHeaderTooltip: '新增个人租赁订单+企业租赁子订单数量',
    },
    {
      name: 'deliverCarNum',
      columnProps: {
        label: '交车数',
        prop: 'deliverCarNum',
      },
      columnHeaderTooltip: '当日已交付出库的全部车辆数',
    },
    {
      name: 'returnCarNum',
      columnProps: {
        label: '退车数',
        prop: 'returnCarNum',
      },
      columnHeaderTooltip: '退车入库全部数量',
    },
    {
      name: 'orderGrowth',
      columnProps: {
        label: '当期净增订单数',
        prop: 'orderGrowth',
      },
      columnHeaderTooltip: '新增订单数-退车入库数量',
    },
    {
      name: 'expiredNum',
      columnProps: {
        label: '当期合同到期数',
        prop: 'expiredNum',
      },
      columnHeaderTooltip: '个人租赁订单+企业租赁子订单到期数',
    },
    {
      name: 'renewalNum',
      columnProps: {
        label: '当期续租数',
        prop: 'renewalNum',
      },
      columnHeaderTooltip: '',
    },
  ]
  return {
    columns,
  }
}
